<template>
  <div>
    <form class="form" @submit.prevent="updateProfile">
      <!-- displayname -->
      <div class="form-group">
        <label class="form-label required" for="displayname">{{ $t('profile.displayname') }}</label>
        <input
          type="text"
          class="form-control"
          :class="{'is-invalid' : error.displayname}"
          id="displayname"
          v-model="form.displayname"
          :disabled="loading"
        />
        <div class="invalid-feedback" v-show="error.displayname">
          <span>{{ error.displayname }}</span>
        </div>
      </div>
      <!-- /displayname -->

      <!-- country -->
      <div class="form-group">
        <label class="form-label required" for="country">{{ $t('profile.country') }}</label>
        <v-select class="form-control-select" :options="countries" label="name" :reduce="countries => countries.val" v-model="selectCountry" @input="setCountry" :clearable="false">
          <template #search="{attributes, events}">
            <input
              class="vs__search"
              :required="!selectCountry"
              v-bind="attributes"
              v-on="events"
            />
          </template>
        </v-select>
      </div>
      <!-- /country -->

      <!-- language -->
      <div class="form-group">
        <label class="form-label required" for="language">{{ $t('language.title') }}</label> 
        <v-select class="form-control-select" :options="languages" label="name" :reduce="languages => languages.val" v-model="selectedLang" @input="selectLanguage" :clearable="false">
          <template #search="{attributes, events}">
            <input
              class="vs__search"
              :required="!selectedLang"
              v-bind="attributes"
              v-on="events"
            />
          </template>
        </v-select>
      </div>

      <!-- address -->
      <div class="form-group">
        <label class="form-label required" for="address">{{ $t('profile.address') }}</label>
        <div class="select3-wrap">
        <select id="address" name="address" class="form-control select3" required v-model="form.address">
          <option></option>
          <option value="resident">{{ $t('profile.resident') }}</option>
          <option value="nonresident">{{ $t('profile.nonresident') }}</option>
        </select>
        </div>
        <div class="invalid-feedback" v-show="error.address">
          <span>{{ error.address }}</span>
        </div>
      </div>
      <!-- /address -->

      <div class="form-group">
        <button type="submit" class="button button-primary checkmark" :disabled="loading">
          <span v-show="loading">{{ $t('common.button.update') }}</span>
          <span v-show="!loading">{{ $t('common.button.update') }}</span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import {api, countrieList, languageKeys, languageList} from "../../../config";

  import vSelect from 'vue-select';
  import 'vue-select/dist/vue-select.css';

  export default {
    components: {
      'v-select': vSelect,
    },
    data() {
      return {
        loading: false,
        error: {
          displayname: '',
          gender: '',
          country: '',
          address: '',
        },
        form: {
          displayname: '',
          gender: '',
          country: '',
          address: ''
        },
        countrySelectList: [],
        languageSelectList: [],
        selectCountry: { val: 'JP', name: "Japan" }
      };
    },
    computed: {
      ...mapGetters([
        'selectedLanguage'
      ]),
      countries () {
        return this.countrySelectList
      },
      languages() {
        return this.languageSelectList
      },
      selectedLang: {
        get() {
          return { name: this.selectedLanguage.native, val: this.selectedLanguage.key }
        },
        set(newVal) {
          this.selectLanguage(newVal)
        }
      }
    },
    created () {
      this.countrySelectList = countrieList
      
      for(let langKey of languageKeys) {
        this.languageSelectList.push({ name: languageList[langKey].native , val: langKey })
        
      }
    },
    mounted () {
        let authUser = this.$store.getters.getAuthUser;
        this.form.displayname = authUser.displayname;
        this.form.country = authUser.country;
        this.form.language = authUser.language;
        this.form.address = authUser.address;
        
        
        this.selectCountry = this.countries.find((countryData) => {
            return (authUser.country && countryData.val.toLowerCase() ==  authUser.country.toLowerCase())
        })
    },
    methods: {
      setCountry(selectKey) {
        this.selectCountry = this.countrySelectList.find(item => {
          return item.val == selectKey
        })
      },
      selectLanguage(language) {
        this.$store.dispatch('selectLanguage', language)
      },
      updateProfile() {
        let self = this;
        this.loading = true;
        this.$store.dispatch('showLoading', true);
        
        let updateForm = this.form
        updateForm['country'] = this.selectCountry.val
        updateForm['language'] = this.$store.getters.selectedLanguage.key;
        
        axios.post(api.updateUserProfile, updateForm)
          .then((res) => {
        
            
            // check auth
            axios.get(api.currentUser)
            .then((resp) => {
                self.$store.dispatch('updateAuthUser', resp.data)
                let authUser = this.$store.getters.getAuthUser;
                
                self.form.displayname = authUser.displayname;
                self.form.country = authUser.country;
                self.form.language = authUser.language;
                self.form.address = authUser.address;
        
                self.$emit('updateSuccess', {});
                self.loading = false;
                self.$store.dispatch('showLoading', false);
            })
            .catch(err => {
              self.$emit('updateSuccess', {});
              self.loading = false;
              self.$store.dispatch('showLoading', false);
            });
            
          })
          .catch(err => {
            (err.response && err.response.data.error)
              ? self.setErrors(err.response.data.error)
              : self.clearErrors();

            self.$store.dispatch('showLoading', false);
            self.loading = false;
          });
      },
      setErrors(errors) {
        this.error.displayname = errors.displayname ? errors.displayname[0] : null;
        this.error.country = errors.country ? errors.country[0] : null;
        this.error.address = errors.gender ? errors.address[0] : null;
      },
      clearErrors() {
        this.error.displayname = null;
        this.error.country = null;
        this.error.address = null;
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
